import React from 'react';
import { Button } from './Button';
export const HeroSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-158">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-159">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center leading-tight" data-id="element-160">
          The Only Trauma-Informed Program Built{' '}
          <em data-id="element-161">For People Who Already Know Somatic Healing Is the Answer</em>
        </h1>
        <div className="mb-12 max-w-3xl mx-auto" data-id="element-162">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rqsGRvYQUSkg6a2cYoVRBa/Orange_And_Red_Modern_Minimalist_The_Most_Attractive_YouTube_Banner_%287%29.png" alt="Hero illustration" className="w-full rounded-lg shadow-xl" data-id="element-163" />
        </div>
        <div className="mb-10 text-lg space-y-4" data-id="element-164">
          <p data-id="element-165">If you already understand that trauma lives in the body...</p>
          <p data-id="element-166">
            If you've read The Body Keeps the Score, followed Irene Lyon, or
            practiced somatic tools...
          </p>
          <p data-id="element-167">If you're tired of therapy that keeps you stuck in your head...</p>
          <p data-id="element-168">Then you're not early in your healing journey.</p>
          <p className="font-bold" data-id="element-169">You're just under-supported.</p>
        </div>
        <div className="flex justify-center" data-id="element-170">
          <Button link={checkoutUrl} data-id="element-171">
            Join for <strike data-id="element-172">$70</strike> $29 ➔
          </Button>
        </div>
      </div>
    </section>;
};